<div class="modal-header">
    <h4 class="modal-title">Security Warning</h4>
    <button type="button" class="close" aria-label="Close" (click)="activeModal.dismiss('Cross click')" style="margin-top: -26px; outline: none">
        <span aria-hidden="true">&times;</span>
    </button>
</div>
<div class="modal-body">
    <p>You have been inactive for at least 5 minutes.</p>
    <p>You will be automatically logged out in {{counter | minuteSeconds}} {{ counterExt }}</p>
</div>
<div class="modal-footer">
    <button type="button" class="btn btn-outline-dark" (click)="cancel()">Cancel</button>
</div>